import React, { Suspense, lazy } from 'react'
import { CircularProgress, Box } from '@mui/material'

// Lazy load billing components to reduce initial bundle size
const BillingManagementPanel = lazy(() => 
  import('./BillingManagementPanel').then(module => ({ 
    default: module.BillingManagementPanel 
  }))
)

const PaymentMethodManager = lazy(() => 
  import('./PaymentMethodManager').then(module => ({ 
    default: module.PaymentMethodManager 
  }))
)

const BillingTierSelector = lazy(() => 
  import('./BillingTierSelector').then(module => ({ 
    default: module.BillingTierSelector 
  }))
)

const BillingHistoryView = lazy(() => 
  import('./BillingHistoryView').then(module => ({ 
    default: module.BillingHistoryView 
  }))
)

const BillingCalculator = lazy(() => 
  import('./BillingCalculator').then(module => ({ 
    default: module.BillingCalculator 
  }))
)

const StripeSubscriptionManager = lazy(() => 
  import('./StripeSubscriptionManager').then(module => ({ 
    default: module.StripeSubscriptionManager 
  }))
)

const BillingStatusWidget = lazy(() => 
  import('./BillingStatusWidget').then(module => ({ 
    default: module.BillingStatusWidget 
  }))
)

// Loading component
const BillingLoadingFallback: React.FC = () => (
  <Box sx={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '200px',
    p: 3 
  }}>
    <CircularProgress sx={{ color: 'primary.main' }} />
  </Box>
)

// Wrapper component for lazy loading with Suspense
export const LazyBillingManagementPanel: React.FC<any> = (props) => (
  <Suspense fallback={<BillingLoadingFallback />}>
    <BillingManagementPanel {...props} />
  </Suspense>
)

export const LazyPaymentMethodManager: React.FC<any> = (props) => (
  <Suspense fallback={<BillingLoadingFallback />}>
    <PaymentMethodManager {...props} />
  </Suspense>
)

export const LazyBillingTierSelector: React.FC<any> = (props) => (
  <Suspense fallback={<BillingLoadingFallback />}>
    <BillingTierSelector {...props} />
  </Suspense>
)

export const LazyBillingHistoryView: React.FC<any> = (props) => (
  <Suspense fallback={<BillingLoadingFallback />}>
    <BillingHistoryView {...props} />
  </Suspense>
)

export const LazyBillingCalculator: React.FC<any> = (props) => (
  <Suspense fallback={<BillingLoadingFallback />}>
    <BillingCalculator {...props} />
  </Suspense>
)

export const LazyStripeSubscriptionManager: React.FC<any> = (props) => (
  <Suspense fallback={<BillingLoadingFallback />}>
    <StripeSubscriptionManager {...props} />
  </Suspense>
)

export const LazyBillingStatusWidget: React.FC<any> = (props) => (
  <Suspense fallback={<BillingLoadingFallback />}>
    <BillingStatusWidget {...props} />
  </Suspense>
)
